/* eslint-disable  */
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import { red, yellow, green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useBoletimContext from 'context/BoletimContext';
import {
  Button,
  ButtonGroup,
  TextField,
  TextFieldProps,
  Tooltip,
} from '@mui/material';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import { IGridBoletim } from 'interfaces/Grid';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@material-ui/core/CircularProgress';

import CheckIcon from '@mui/icons-material/Check';

import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

import { postAddBoletimDiverse } from 'services/boletimDiverse';
import dayjs from 'dayjs';
import { postAddBoletim } from 'services/daily-bulletin';

// Set the row background colors
const status = [yellow[50], green[50], null, red[50]];
const backgroundColorRows = {};
for (let i = 0; i < status.length; i += 1) {
  if (status[i] != null) {
    backgroundColorRows[`&:nth-child(${i + 1})`] = {
      backgroundColor: status[i],
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  inputBorder: {
    border: 'none',
  },

  header: {
    display: 'flex',
    zIndex: 1111,
    position: 'fixed',
    background: '#fff',
    width: '100%',
    padding: '98px 0 0 10px',
  },

  h2: {
    color: 'rgb(88, 147, 241)',
    display: 'inline-block',
    fontSize: '1.15rem',
    marginRight: '12px',
    marginTop: '13px',
  },
  button: {
    width: '20px',
    padding: '6px',
  },
  mt5: { marginTop: '5px' },
  redStatus: { color: '#ff00009e' },
  yellowStatus: { color: '#ffff00a0' },
  greenStatus: { color: '#008000a7' },
  buttonGroup: { margin: '8px 4px' },
  singleButton: {
    margin: '8px 4px',
    padding: '5px',
  },
  container: {
    width: '100%',
    marginBottom: '15px',
    height: '600px',
    overflow: 'auto',

    '& .MuiDataGrid-cellContent': {
      fontSize: '13px',
    },
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'scroll !important ',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      maxHeight: '585px !important',
    },
    ' & .statusC': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 12,
      height: 12,
      borderRadius: '100%',
    },
  },
}));

// Set the icon for the columns "Ind." and "Apr."
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NewDailyBulletinPreviewGrid = ({
  toggleState,
  installationSelected,
}: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const toggle = toggleState;
  const handleRowsRed = txtStatus => {
    const txtObs: any = inputDataInicial.current?.value;
    const linhasEscolhidas = linhasSelecionadas;
    linhasEscolhidas.forEach(function (id) {
      setBoletinsWTG(
        boletinsWTG.map(function (row) {
          if (row.id === id) {
            const linhaEditada = row;
            linhaEditada.bulletinStatus = 'Parada';
            return linhaEditada;
          }
          return row;
        }),
      );
    });
    onReset();
  };

  const handleRowsYellow = txtStatus => {
    const linhasEscolhidas = linhasSelecionadas;
    linhasEscolhidas.forEach(function (id) {
      setBoletinsWTG(
        boletinsWTG.map(function (row) {
          if (row.id === id) {
            const linhaEditada = row;
            linhaEditada.bulletinStatus = 'Andamento';
            return linhaEditada;
          }


          return row;
        }),
      );
    });
    onReset();
  };

  const handleRowsGreen = txtStatus => {
    const linhasEscolhidas = linhasSelecionadas;
    linhasEscolhidas.forEach(function (id) {
      setBoletinsWTG(
        boletinsWTG.map(function (row) {
          if (row.id === id) {
            const linhaEditada = row;
            linhaEditada.bulletinStatus = 'Operacao';
            return linhaEditada;
          }
          return row;
        }),
      );
    });
    onReset();
  };

  const classes = useStyles();

  const { boletinsWTG, setBoletinsWTG } = useBoletimContext();
  const [openDialogExcluir, setOpenDialogExcluir] = useState<boolean>(false);
  const [openDialogEditar, setOpenDialogEditar] = useState<boolean>(false);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState<any[]>([]);
  const inputDataInicial = useRef<TextFieldProps>(null);
  const [editingCell, setEditingCell] = useState(null);
  const [rowEdited, setRowEdited] = useState('');
  const [showButton, setShowButon] = useState(true);

  useEffect(() => {
    setBoletinsWTG([]);
  }, [installationSelected]);

  const onReset = () => {
    setLinhasSelecionadas([]);
  };

  const switchIcon = params => {
    setBoletinsWTG(
      boletinsWTG.map(function (row) {
        if (row.id === params?.id) {
          const linhaEditada = row;
          linhaEditada.utilization =
            params?.row?.utilization === 'S' ? 'N' : 'S';
          return linhaEditada;
        }
        return row;
      }),
    );
    onReset();
  };

  const switchIcon6 = params => {
    setBoletinsWTG(
      boletinsWTG.map(function (row) {
        if (row.id === params?.id) {
          const linhaEditada = row;
          linhaEditada.outage = params?.row?.outage === 'S' ? 'N' : 'S';
          return linhaEditada;
        }
        return row;
      }),
    );
    onReset();
  };

  const handleCellEditEnd = (event, params) => {
    setShowButon(true);
    const newValue = event.target.value;
    setEditingCell(null);
    setBoletinsWTG(
      boletinsWTG.map(row => {
        if (row.id === params.id) {
          const linhaEditada = { ...row };
          linhaEditada.observationField = newValue;
          setRowEdited(linhaEditada.observationField);
          return linhaEditada;
        }
        return row;
      }),
    );
  };

  const columns: GridColDef[] = [
    {
      field: 'tipo',
      headerName: 'Disciplina',
      width: 70,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: 'equipmentTag',
      headerName: 'Equip.',
      width: 80,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip
          title={
            params?.row?.tipo === 'BOP'
              ? params?.row?.equipment
              : params?.row?.equipmentTag || params?.row?.area
          }
        >
          <span>
            {params?.row?.tipo === 'BOP'
              ? params?.row?.equipment
              : params?.row?.equipmentTag || params?.row?.area}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'activity',
      headerName: 'Atividade',
      width: 160,
      flex: 0.5,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.activity}>
          <span>{params?.row?.activity}</span>
        </Tooltip>
      ),
    },
    {
      field: 'startPrevBr',
      headerName: 'Início',
      width: 125,
      editable: false,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.startPrevBr}>
          <span>{params?.row?.startPrevBr}</span>
        </Tooltip>
      ),
    },
    {
      field: 'completionPrev',
      headerName: 'Final',
      width: 125,
      editable: false,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.completionPrev}>
          <span>{params?.row?.completionPrev}</span>
        </Tooltip>
      ),
    },
    {
      field: 'utilization',
      headerName: 'Aprov.',
      width: 25,
      editable: false,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        if (params?.row?.activityPlanId == null && params?.row?.tipo === 'BOP') {
          params.row.utilization = 'N';
          return (
            <Tooltip title={params?.row?.utilization}>
              <div>
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );
        } else if (params?.row?.tipo === 'OUTROS') {
          params.row.utilization = 'N';
          return (
            <Tooltip title={params?.row?.utilization}>
              <div>
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );
        } else if (params?.row?.utilization === 'S') {
          return (
            <Tooltip title={params?.row?.utilization}>
              <div
                onClick={() => {
                  switchIcon(params);
                }}
              >
                <CheckIcon color="success" sx={{ fontSize: 20 }} />
              </div>
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title={params?.row?.utilization}>
              <div
                onClick={() => {
                  switchIcon(params);
                }}
              >
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );
        }
      },
    },
    {
      field: 'outage',
      headerName: 'Ind.',
      width: 25,
      editable: true,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        if (params?.row?.activityPlanId == null && params?.row?.tipo === 'BOP') {
          params.row.utilization = 'N';
          return (
            <Tooltip title={params?.row?.utilization}>
              <div>
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );

        } else if (params?.row?.tipo === 'OUTROS') {
          params.row.utilization = 'N';
          return (
            <Tooltip title={params?.row?.utilization}>
              <div>
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );
        } else if (params?.row?.outage === 'S') {
          return (
            <Tooltip title={params?.row?.outage}>
              <div
                onClick={() => {
                  switchIcon6(params);
                }}
              >
                <CheckIcon color="success" sx={{ fontSize: 20 }} />
              </div>
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title={params?.row?.outage}>
              <div
                onClick={() => {
                  switchIcon6(params);
                }}
              >
                <CloseIcon sx={{ fontSize: 20, color: red[500] }} />
              </div>
            </Tooltip>
          );
        }
      },
    },
    {
      field: 'bulletinStatus',
      headerName: 'Status',
      width: 60,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => (
        <div
          title={params?.row?.bulletinStatus}
          className="statusC"
          style={{
            background:
              params?.row?.bulletinStatus === 'Parada'
                ? 'red'
                : params?.row?.bulletinStatus === 'Andamento'
                ? 'yellow'
                : 'green',
          }}
        ></div>
      ),
    },
    {
      field: 'observationField',
      headerName: 'Observação',
      width: 160,
      editable: true,
      resizable: true,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        return (
          <TextField
            className={classes.inputBorder}
            autoFocus
            fullWidth
            value={params.row.observationField}
            onBlur={event => handleCellEditEnd(event, params)}
            onKeyDown={event => {
              setShowButon(false);
              if (event.key === 'Enter') {
                event.preventDefault();
                handleCellEditEnd(event, params);
                setShowButon(true);
              }
            }}
          />
        );
      },
    },
  ];

  const handleDelete = () => {
    const rowsRemove = linhasSelecionadas;
    const rowsAll: IGridBoletim[] = boletinsWTG.slice();

    setBoletinsWTG([]);
    let semLinhaExcluida: IGridBoletim[] = [];
    let zerada: IGridBoletim[] = [];

    rowsAll.forEach(function (row) {
      let isJaExistenteNoGrid = true;
      rowsRemove.forEach(function (j) {
        if (j == row.id) {
          isJaExistenteNoGrid = false;
        }
      });
      if (isJaExistenteNoGrid) {
        semLinhaExcluida.push(row);
      }
    });
    setBoletinsWTG(semLinhaExcluida);
    setLinhasSelecionadas(zerada);

    setOpenDialogExcluir(false);
  };

  const exportBoletimDiverse = useCallback(() => {
        setIsLoading(true);
    const abaDiversosItems: IGridBoletim[] = [];
    const nonabaDiversosItems: IGridBoletim[] = [];
        // Dividindo os dados do Grid, pois a aba Diverse, recebe os dados em outra api
    boletinsWTG.forEach(item => {
      if (item.tipo === 'OUTROS') {
        abaDiversosItems.push(item);
      } else {
        nonabaDiversosItems.push(item);
      }
    });

    //tratamento dos dados para envio conforme api
    const tempRowsDiverse = abaDiversosItems.map((item, j) => ({
      activityDescription:
        item.tipo === 'OUTROS' ? item.activityDescription : '',
      area: item.area,
      bulletinFlag: true,
      bulletinStatus:
        item.bulletinStatus == undefined ? 'Operacao' : item.bulletinStatus,
      duration: dayjs(item.completionPrev, 'DD/MM/YYYY HH:mm').diff(
        dayjs(item.startPrevBr, 'DD/MM/YYYY HH:mm'),
        'hour',
      ),
      equipmentId: item.equipmentId,
      installationId: Number(item.installationId),
      observationField:
        item.observationField == undefined ? '' : item.observationField,
      planNumber: dayjs().year(),
      providerDescription: item.providerDescription,
      completion: dayjs(item.completionPrev, 'DD/MM/YYYY HH:mm').toISOString(),
      start: dayjs(item.startPrevBr, 'DD/MM/YYYY HH:mm').toISOString(),
    }));
    if (tempRowsDiverse.length > 0) {
      postAddBoletimDiverse(tempRowsDiverse)
        .then(response => {
          if (response.statusCode === 200) {
            window.location.replace('/boletim-diario');
          }
        })
        .catch(error => {
          console.error(error);
          // Tratar erro aqui
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    setIsLoading(true);
    //////Segundo Envio: enviando ao BAck os demais abas
    const tempRows = nonabaDiversosItems.map((item, j) => ({
      id: j,
      activityName: '',
      activityId: item.activitiesId,
      clusterId: item.clusterId,
      installationId: Number(item.installationId),
      maintenance: item.maintenance
        .toLowerCase()
        .replace(/(^|\s)\S/g, function (firstLetter) {
          return firstLetter.toUpperCase();
        }),

      equipmentId: item.equipmentId,
      startPrev: dayjs(item.startPrevBr, 'DD/MM/YYYY HH:mm').toISOString(),
      completionPrev: dayjs(
        item.completionPrev,
        'DD/MM/YYYY HH:mm',
      ).toISOString(),
      durationPrev: dayjs(item.completionPrev, 'DD/MM/YYYY HH:mm').diff(
        dayjs(item.startPrevBr, 'DD/MM/YYYY HH:mm'),
        'hour',
      ),
      providerName: item.providerName,
      outage: item.outage,
      utilization: item.utilization,
      completionPercentage: 0,
      planNumber: dayjs().year(),
      observationField:
        item.observationField == undefined ? '' : item.observationField,
      bulletinFlag: true,
      bulletinStatus:
        item.bulletinStatus == undefined ? 'Operacao' : item.bulletinStatus,
      activityPlanId: item.activityPlanId || null,
    }));

    console.log('570 tempRows',tempRows);
    if (tempRows.length > 0) {
      postAddBoletim(tempRows)
        .then(response => {
          if (response.statusCode === 200) {
            window.location.replace('/boletim-diario');
          }
        })
        .catch(error => {
          console.error(error);
          // Tratar erro aqui
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [boletinsWTG]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>{/* <GridToolbarExport /> */}</GridToolbarContainer>
    );
  }

  return (
    <>
      <div className={classes.root}>
        <h2 className={classes.h2}>Boletim</h2>

        <ButtonGroup
          color="primary"
          aria-label="outlined primary button group"
          className={classes.buttonGroup}
        >
          <Button
            className={`${classes.button}`}
            title="Status: Parada"
            onClick={handleRowsRed}
          >
            {/* Par */}
            <FiberManualRecordIcon className={classes.redStatus} />
          </Button>

          <Button
            className={`${classes.button}`}
            title="Status: Andamento"
            onClick={handleRowsYellow}
          >
            <FiberManualRecordIcon className={classes.yellowStatus} />
          </Button>

          <Button
            className={`${classes.button}`}
            title="Status: Em operação"
            onClick={handleRowsGreen}
          >
            <FiberManualRecordIcon className={classes.greenStatus} />
          </Button>
        </ButtonGroup>
        <Button
          variant="outlined"
          color="primary"
          className={`${classes.button} ${classes.singleButton}`}
          aria-label="outlined primary button"
          title="Adicionar observação"
          disabled={isLoading === true}
          onClick={() => {
            setOpenDialogEditar(true);
          }}
        >
          <CommentOutlinedIcon />
        </Button>
        <Button
          style={{ marginLeft: '5px' }}
          variant="outlined"
          color="error"
          disabled={isLoading === true}
          // onClick={handleDelete}
          onClick={() => {
            setOpenDialogExcluir(true);
          }}
          className={`${classes.button} ${classes.singleButton}`}
          title="Remover atividade"
          aria-label="outlined primary button"
        >
          <DeleteOutlineOutlinedIcon style={{ color: red[500] }} />
        </Button>

        {showButton && (
          <Button
            style={{ marginLeft: '5px', width: '100px' }}
            variant={'outlined'}
            onClick={exportBoletimDiverse}
            className={`${classes.button} ${classes.singleButton}`}
            title="salvar"
            arial-label="primary button"
            disabled={isLoading === true}
          >
            Salvar
          </Button>
        )}
        {isLoading && <CircularProgress />}
      </div>

      <DataGrid
        className={classes.container}
        rows={boletinsWTG}
        columns={columns}
        headerHeight={30}
        rowHeight={30}
        checkboxSelection
        components={{
          Toolbar: CustomToolbar,
        }}
        autoHeight
        // hideFooter
        hideFooterSelectedRowCount
        // hideFooterPagination
        onSelectionModelChange={setLinhasSelecionadas}
        selectionModel={linhasSelecionadas}
        disableSelectionOnClick
      />

      <Dialog
        open={openDialogEditar}
        onClose={() => {
          setOpenDialogExcluir(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Digite a observação necessária.
        </DialogTitle>
        <DialogContent>
          <TextField
            id="txtObservacao"
            label="Observação:"
            multiline
            rows={4}
            inputRef={inputDataInicial}
            defaultValue=""
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
            }}
            style={{ color: red[500] }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
              const txtObs: any = inputDataInicial.current?.value;
              const linhasEscolhidas = linhasSelecionadas;
              linhasEscolhidas.forEach(function (id) {
                setBoletinsWTG(
                  boletinsWTG.map(function (row) {
                    if (row.id === id) {
                      const linhaEditada = row;
                      linhaEditada.observationField = txtObs;
                      return linhaEditada;
                    }
                    return row;
                  }),
                );
              });
              onReset();
            }}
            color="primary"
          >
            Alterar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogExcluir}
        onClose={() => {
          setOpenDialogExcluir(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
          Confirma a exclusão das linhas selecionada(s)
        </DialogTitle>
        <DialogContent
          style={{
            fontSize: 16,
            color: '#000000b7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          Deseja cancelar as atividades selecionada(s)?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogExcluir(false);
            }}
            style={{ color: red[500] }}
          >
            Cancelar
          </Button>
          <Button onClick={handleDelete} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewDailyBulletinPreviewGrid;